class CustomPopup extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      popupLinks : this.querySelectorAll(".popup-header"),
      popupPages : this.querySelectorAll(".popup-page"),
      closeButton: this.querySelectorAll('.close-button'),
    }
    Array.from(this.elements.popupLinks).forEach((popupLink) => {
      popupLink.addEventListener("click", (event) => {
        const popupIndex = event.target.id.split("_")[1] - 1;
        this.showPopup(popupIndex, popupLink);
      });
    });
    this.elements.closeButton.forEach(btn => btn.addEventListener('click', () => this.closePopup()));
  }

  showPopup(popupIndex, element) {
    document.querySelector('body').classList.add('overflow-hidden');
    this.elements.popupPages[popupIndex].classList.add("active");

    if (element.closest('.image-with-text')) {
      element.closest('.image-with-text').style.zIndex = "9999999";
    }


    if ( document.querySelector('.image-with-text__text-item.grid__item') !== null) {
      document.querySelector('.image-with-text__text-item.grid__item').style.zIndex = "9999999";
    }
    this.elements.popupLinks[popupIndex].classList.add("active");
  }
  closePopup(popupIndex) {
    document.querySelector('body').classList.remove('overflow-hidden');
    Array.from(this.elements.popupPages).forEach((popupPage) => popupPage.classList.remove("active"));
    Array.from(this.elements.popupLinks).forEach((popupLink) => popupLink.classList.remove("active"));

    document.querySelectorAll('.image-with-text').forEach(el => el.style.zIndex = "999");

    if (document.querySelector('.image-with-text__text-item.grid__item') !== null) {
      document.querySelector('.image-with-text__text-item.grid__item').style.zIndex = "999";
    }
  }
}

customElements.define('custom-popup', CustomPopup);





